const production = {
  EVENTS_ENDPOINT: '/wp-json/fkn/v1/events',
  TAXONOMY_ENDPOINT: '/wp-json/wp/v2/event_post_type_taxonomy',
  SITE_HOST: 'production',
};

const stage = {
  EVENTS_ENDPOINT: '/wp-json/fkn/v1/events',
  TAXONOMY_ENDPOINT: '/wp-json/wp/v2/event_post_type_taxonomy',
  SITE_HOST: 'stage',
};

const local = {
  EVENTS_ENDPOINT: '/noedhjaelp/wp-json/fkn/v1/events',
  TAXONOMY_ENDPOINT: '/noedhjaelp/wp-json/wp/v2/event_post_type_taxonomy',
  SITE_HOST: 'local',
};

function getConstant( name ) {
  switch ( window.location.hostname ) {
    case 'fkn.wp.stage.ng.peytz.dk':
      return stage[name];
    case 'fkn.test':
      return local[name];
    case 'localhost':
      return local[name];
    default:
      return production[name];
  }
}

export const EVENTS_ENDPOINT   = getConstant( 'EVENTS_ENDPOINT' );
export const TAXONOMY_ENDPOINT = getConstant( 'TAXONOMY_ENDPOINT' );
export const SITE_HOST         = getConstant( 'SITE_HOST' );
